const numberFormatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  maximumFractionDigits: 0,
})

export function formatNumberWithCommas(number: number) {
  const formattedNumber = numberFormatter.format(number)
  return formattedNumber
}
